import {getURLParameter} from "~/common/utils";


// Ad Configuration
export const autoAds = window.evite.dfp.autoAds;
window.getURLParameter = getURLParameter;

// Segment Configuration
class DataLayer {

    get LAST_USER_KEY() {
        return 'tags_last_user';
    };

    get partners() {
        return ['vista', 'pb', 'pbk', 'ws'];
    };

    get keys_saved() {
        return ['session_id', 'surround_id', 'segments', 'segments_checked'];
    };

    get storage_key () {
        return 'client_data_layer_saved';
    };

    constructor (client_data) {
        this.dl = Object.assign({}, client_data);
        this.dl.page_id = new Date().getTime();
        this.sync();
    };

    load () {
        // load previous data from storage

        if (!store) {
            return;
        }

        let stored = store.get(this.storage_key);

        if (!stored) {
            return;
        }

        for (let key of Object.keys(stored)) {
            if (this.dl[key] == null) {
                this.dl[key] = stored[key];
            }
        }
    };

    ext () {
        let s = {};
        if (this.dl) {
            for (let name of Object.keys(this.dl)) {
                if (name !== 'email') {
                    s[name] = this.dl[name];
                }
            }
        }
        return s;
    };

    save (push=true) {
        // Saves to local storage and updates the data layer

        if (!store) {
            return;
        }

        let v = {};  // copy so we don't change it
        // some stuff we don't want to save
        for (let key of this.keys_saved) {
            if (Object.keys(this.dl).indexOf(key) >= 0) {
                v[key] = this.dl[key];
            }
        }

        let key = this.storage_key;
        store.set(key, v);

        // save the last key so we can find it on pages where the server doesn't know the key
        store.set(this.LAST_USER_KEY, key || '');
        if (push) {
            return window.dataLayer.push(this.ext());
        }
    };

    sync () {
        // sync storage - don't overwrite any value provided from the server
        // this exists to persist values between page loads even when the server doesn't provide them.
        try {
            this.load();
            this.save();
        }
        catch(e) {
            if(window.Raven) {
                window.Raven.captureException(e);
            }
        }
    };

    push (name, value) {
        // set a value in the gtm datalayer and client
        this.dl[name] = value;
        let p = {};
        p[name] = value;
        window.dataLayer.push(p);
        return this;
    };

    page_event (url, name) {
        try {
            if ((name == null) && (url != null)) {
                name = url;
                url = undefined;
            }
            if (url == null) {
                url = window.location.pathname;
            }

            let pos = url.indexOf('?');
            if (pos > -1) {
                url = url.substring(0, pos);
            }
            if (url.length > 1 && url.match(/\/$/)) {
                url = url.substring(0, url.length - 1);
            }

            window.dataLayer.push({
                event: url + ';' + name
            });
        } catch (error) {
            if (window.console != null) {
                // console.log(error);
            }
        }
    };

    track_event (name, data) {
        if (!data) {
            data = {};
        }

        for (let key of Object.keys(data)) {
            this.dl[key] = data[key];
        }
        this.save(false);

        //  adding events for soasta
        if (window.track_event) {
            window.track_event[name] = data;
        }

        data['event'] = name;
        window.dataLayer.push(data);
    };

    ga_event (opts) {
        // send an event to analytics
        // example:
        //    tags.ga_event
        //      eventCategory: 'Template Performance'
        //      eventAction: window.event_data.event_type
        //      eventLabel: window.event_data.template_name
        //      eventValue: guest_list.length

        if (window.track_event) {
            window.track_event[`ga_${opts.eventCategory}`] = opts;
        }

        let eventName = 'GAEvent';
        if (opts.eventName) {
            eventName = opts.eventName;
        }

        window.dataLayer.push({
            event: eventName,
            eventCategory: opts.eventCategory,
            eventAction: opts.eventAction,
            eventLabel: opts.eventLabel,
            eventValue: opts.eventValue
        });
    };

    set_adid (adid) {
        // this is called from the fif.html page with -1. code is ported from razor's ads.js
        let sid = this.dl.surround_id;
        if (adid !== -1) {
            sid = adid;
        }

        if (sid <= 0) {
            sid = undefined;
        }
        this.push("surround_id", sid);
        this.save(false);
    };

    check_segments (callback) {
        // retrieves partner subscriptions for the guest
        if (!this.dl.evc_h || !this.dl.evc_s) {
            if (callback) {
                callback();
            }
            return;
        }

        if ((this.dl.segments_checked != null) && new Date().getTime() - this.dl.segments_checked < 86400000) {  // one day
            if (callback) {
                callback();
            }
            return;
        }

        window.$.ajax({
            url: "//evite-analytics.appspot.com/segments",
            type: 'GET',
            data: {
                h: this.dl.evc_h,
                sh: this.dl.evc_s
            },
            success: (data) => {
                this.dl['segments'] = data.segments;
                this.dl.segments_checked = new Date().getTime();
                this.save(false);
                this.push('segments', data.segments);
                this.track_event('segments_data_loaded');
                if (callback) {
                    return callback();
                }
            },
            error: () => {
                if (callback) {
                    return callback();
                }
            },
            crossDomain: true,
            dataType: "jsonp"
        });
    };

    h () {
        if (!this.dl.email || !this.dl.user_id) {
            return;
        }
    };

}


try {
    window.dl = new DataLayer(window.client_data);
    window.tags = window.dl;
}
catch(e) {
    Raven.captureException(e);
}


export function getGPTParam(arr) {
    if (!(arr instanceof Array)) {
        arr = [arr];
    }

    for (let k of arr) {
        if (window.client_data && window.client_data.hasOwnProperty(k)) {
            return window.client_data[k];
        }
        if (window.dl.dl && window.dl.dl.hasOwnProperty(k)) {
            return window.dl.dl[k];
        }
    }

    return null;
}

export const paramList = window.paramList = [];
function addGPTParam(k, v) {
    if (v !== null) {
        googletag.pubads().setTargeting(k, v + "");
        window.paramList += `${k}=${v}&`;
    }
};

function criteoBids() {
    if (window.crtg_content) {
        googletag.cmd.push(function() {
            let crtg_split = crtg_content.split(';');
            for (let kv of crtg_split) {
                let value = kv.split('=');
                googletag.pubads().setTargeting("" + (value[0] + ""), "" + (value[1] + ""));
            }
        });
    }
};

function loadParams() {
    googletag.cmd.push(function() {
        if (window.amznads && window.amznads.tasks) {
            window.amznads.tasks.push(function() {
                return window.amznads.setTargetingForGPTAsync('amznslots');
            });
        }
    
        addGPTParam("login", getGPTParam("is_logged_in"));
        addGPTParam("host", getGPTParam("is_host"));
        addGPTParam("g", getGPTParam("user_gender"));
        addGPTParam("city_ps", getGPTParam("user_city"));
        addGPTParam("zip_ps", getGPTParam("user_zip_code"));
        addGPTParam("pt", getGPTParam(["pagetype", "zone"]));
        addGPTParam("page_url", window.location.href);
        addGPTParam("demo", window.getURLParameter("demo"));
        const zone = window.client_data.zone;
        if (zone !== "myevite") {
            addGPTParam("charity", getGPTParam("charity"));
            addGPTParam("cj_aid", getGPTParam("cj_aid"));
            addGPTParam("cj_oid", getGPTParam("cj_pid"));
            addGPTParam("dc_ref", getGPTParam("dc_ref"));
            addGPTParam("due", getGPTParam("event_days_until"));
            addGPTParam("doe", getGPTParam("event_day"));
            addGPTParam("dur", getGPTParam("event_duration"));
            addGPTParam("eid", getGPTParam("event_id"));
            addGPTParam("em", getGPTParam("evc"));
            addGPTParam("est", getGPTParam("event_time"));
            addGPTParam("etn", getGPTParam("event_age_of_child"));
            addGPTParam("ev_hm", getGPTParam("ev_hm"));
            addGPTParam("f", getGPTParam("event_step"));
            addGPTParam("filter", getGPTParam("filter_list"));
            addGPTParam("gifting", getGPTParam("event_gifting_enabled"));
            addGPTParam("kw", getGPTParam("kw"));
            addGPTParam("k", getGPTParam("KEYWORD_ID"));
            addGPTParam("response", getGPTParam("response"));
            addGPTParam("rm", getGPTParam("event_rsvp_maybe"));
            addGPTParam("rn", getGPTParam("event_rsvp_no"));
            addGPTParam("ru", getGPTParam("event_rsvp_undecided"));
            addGPTParam("rt", getGPTParam("event_rsvp_total"));
            addGPTParam("ry", getGPTParam("event_rsvp_yes"));
            addGPTParam("si", getGPTParam("session_id"));
            addGPTParam("state_ctxt", getGPTParam("event_state"));
            addGPTParam("template", getGPTParam("template"));
            addGPTParam("tkg", getGPTParam("t_g"));
            addGPTParam("ty", getGPTParam("template_type"));
            addGPTParam("zip_ctxt", getGPTParam("event_zip"));
            addGPTParam("miles", getGPTParam("event_guest_distance"));
    
            if(!['signin', 'partner_page'].includes(zone)) {
                addGPTParam("srnd", getGPTParam("surround_id"));
            }
        }
    
        const reg_names = getGPTParam("reg_names");
    
        if (reg_names) {
            // Flatten, lowercase and strip invalid chars from reg_names array
            const registry = reg_names.map(function(name){
              return name.toLowerCase().replace(/\W+/g, '');
            }).join(',');
    
            addGPTParam("registry", registry);
        }
    
        let gpt = document.location.pathname.match(/^\/c\/([^\/]*)/i);
        if (gpt) {
            addGPTParam("cp", gpt[1]);
        }
    
        googletag.pubads().enableAsyncRendering();
        googletag.pubads().collapseEmptyDivs();
        googletag.enableServices();
    });
}

loadParams();

function sort_elements_by_placement(a, b) {
    let an = $(a).offset().top;
    let bn = $(b).offset().top;

    if (an > bn)
        return 1;
    if (an < bn)
        return -1;
    return 0;
}


let refreshImmediate = Raven.wrap(function() {
    criteoBids();
    loadParams();
    googletag.cmd.push(function() {
        googletag.pubads().setTargeting("amznslots", "");
        googletag.pubads().refresh();
    });
});


(function(){
   function debounce(func, wait, immediate) {
       let timeout;
       let result;
       function delay(func, wait, ...args) {
           return setTimeout(function () {
               return func.apply(null, args);
           }, wait);
       }
       function later(context, args) {
           timeout = null;
           if (args) {
               result = func.apply(context, args);
           }
       }
       function debounced(...args) {
           if (timeout) {
               clearTimeout(timeout);
           }
           if (immediate) {
               var callNow = !timeout;
               timeout = setTimeout(later, wait);
               if (callNow) {
                   result = func.apply(this, args);
               }
           } else {
               timeout = delay(later, wait, this, args);
           }
           return result;
       }
       debounced.cancel = function () {
           clearTimeout(timeout);
           timeout = null;
       };
       return debounced;
   }
   window.refreshAds = debounce(refreshImmediate, window.adrefresh_debounced_timer || 500, true);
}());


export const renderAutoAds = Raven.wrap(function() {
    evite.when('dfp').then(function(){
        criteoBids();

        // TODO - Investigate removal of jquery dependency
        const sorted = $(".gpt-ad.gpt-auto,.gpt-ad.gpt-oop.gpt-rsvp").sort(sort_elements_by_placement);
        sorted.each(function(i, el) {
            window.googletag.cmd.push((function(el) {
                window.adSlots[el.id] = true;
                window.googletag.display(el.id);
                $(el).addClass("gpt-loaded");
            })(el));
        });
        evite.resolve('googletag.render-auto-ads');
    });
});

// for compatibility. we don't need to debounce since
// we're tracking which ads have finished loading
export const debouncedRefreshAds = window.debouncedRefreshAds = refreshAds;
// not using this anymore
export const adSlots = window.adSlots = {};

evite.when('dfp').then(function() {
    evite.requestIdleCallback(function(){
        window.dl.check_segments();
        window.tags.track_event('tag_data_loaded');
    });
});

Object.assign(evite.dfp, exports);
evite.when('page.render', 'block js').then(function() {
  evite.resolve('dfp', evite.dfp);
});



// WEBPACK FOOTER //
// ./assets/es6/common/dfp.es6